import React from 'react';
import ReactDOM from "react-dom";
import Invoice from './invoice';
import Customer from './customer';
import UserProfile from './userProfile';
import Loader from './loader';

export default class Clients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            isSubmitting: false,
            clients: []
        };
    }

    componentDidMount() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php?event=cliens-get&userID=' + userID + '&uCompanyID=' + uCompanyID;
        fetch(url, {
            method: "POST",
            //body: JSON.stringify(UserProfile.getUserID, UserProfile.getCompanyID),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(res => {
                this.setState({ isSubmitting: false });
                return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        clients: result
                    });
                    //console.log(result);
                    this.clientsGet(result);
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    itemsGet(companyID) {
        new Invoice().itemsGet(companyID);
    }

    customerGet(companyID) {
        new Customer().customerGetInfo(companyID);
    }

    itemsNarrow() {
        new Invoice().narrowRead();
    }

    clientsGet(clients) {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        var narrow = <div className='row'>
            <input id='narow' onKeyDown={() => this.itemsNarrow()} type='text' placeholder={'Szűkítés'} />
        </div>;
        const res = clients.map((client) =>
            <li className='list' key={client.name}>
                <a href="#" onClick={() => this.itemsGet(client.companyID)}>
                    {client.name}
                </a>
                <span onClick={() => this.customerGet(client.companyID)}></span>
            </li>
        );
        setTimeout(function () {
            ReactDOM.render(
                <div>{narrow}<ul id='list'>{res}</ul></div>, document.getElementById('invoiceBody')
            );
        }, 100);
    }

    render() {
        return (
            <ul>
            </ul>
        );
    }

}